import { Space } from 'antd';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '../../typography';

export type EmptyDescriptionProperties = DescriptionOptions | Exclude<ReactNode, PromiseLike<unknown>>;

type DescriptionOptions = { subtitle?: string; title: string };

const isDescriptionOptions = (data: EmptyDescriptionProperties): data is DescriptionOptions =>
  Boolean(data && typeof data === 'object' && 'title' in data);

type P = {
  description: EmptyDescriptionProperties;
};

export const EmptyDescription = ({ description }: P) => {
  const { t } = useTranslation();

  if (typeof description === 'string') {
    return t(description);
  }

  if (isDescriptionOptions(description)) {
    return (
      <Space orientation="vertical" size="small">
        <Text size="large" weight="bold">
          {description.title}
        </Text>
        {description.subtitle ? <Text>{description.subtitle}</Text> : null}
      </Space>
    );
  }

  return description;
};
